// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyD2xzi5wgGf-6KVMbgaTzPSgFYgHZXKT6U",
    authDomain: "rescuedesk-e9c46.firebaseapp.com",
    databaseURL: "https://rescuedesk-e9c46.firebaseio.com",
    projectId: "rescuedesk-e9c46",
    storageBucket: "rescuedesk-e9c46.appspot.com",
    messagingSenderId: "842607689158",
    appId: "1:842607689158:web:a5eb2510be1469ce"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
